export class CustomTimeEditor {
  init(params) {
    this.params = params;
    this.eInput = document.createElement('input');
    this.eInput.type = 'time';
    this.eInput.step = '1'; // Enable seconds input

    // Apply AG Grid theme variables for styling
    this.eInput.style.boxSizing = 'border-box'; // Crucial for height and width management
    this.eInput.style.width = '100%';
    this.eInput.style.height = '100%'; // Make it fill the cell's height

    // Apply AG Grid classes for consistent styling and behavior, which might be crucial for Quartz theme.
    this.eInput.classList.add('ag-input-field-input', 'ag-text-field-input');

    let initialValue = params.value;
    if (initialValue) {
      let date;
      // Check if initialValue is a full ISO string or just a time string
      if (initialValue.includes('T')) {
        date = new Date(initialValue);
      } else {
        // Try to parse as time string, assuming today's date for the Date object
        const [hours, minutes, seconds] = initialValue.split(':').map(Number);
        if (hours !== undefined && minutes !== undefined) {
          date = new Date();
          date.setHours(hours, minutes, seconds || 0, 0);
        }
      }

      if (date && !isNaN(date.getTime())) {
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        this.eInput.value = `${hours}:${minutes}:${seconds}`;
        // const seconds = date.getSeconds().toString().padStart(2, '0'); // Uncomment if seconds are needed
        this.eInput.value = `${hours}:${minutes}`; // Or `${hours}:${minutes}:${seconds}`
      }
    }

    this.eInput.addEventListener('keydown', event => {
      if (event.key === 'Enter') {
        params.stopEditing();
      } else if (event.key === 'Escape') {
        params.stopEditing(true); // true to cancel changes
      }
    });
  }

  getGui() {
    return this.eInput;
  }

  afterGuiAttached() {
    this.eInput.focus();
  }

  getValue() {
    // The value from <input type="time" step="1"> will be in "HH:mm:ss" format
    // If the input is empty, this.eInput.value will be an empty string.
    // Return null if empty, consistent with CustomDateTimeEditor
    if (this.eInput.value) {
      return this.eInput.value;
    }
    return null;
  }

  isPopup() {
    return false; // Display the editor inline
  }

  destroy() {
    // Perform any cleanup tasks here, if necessary
  }
}
